// Module
var code = "<div class=bible> <div class=bibletext> <p> <span class=cwvnum>11</span>&nbsp;&nbsp;Save your people and bless your inheritance;&nbsp;<span class=redlight>&#149;</span><br/>&nbsp;&nbsp;&nbsp;shepherd them and carry them for ever.<br> </p> </div></div>";
// Exports
module.exports = code;